import { render, staticRenderFns } from "./ArchiveNotification.vue?vue&type=template&id=f93612ce&scoped=true"
import script from "./ArchiveNotification.vue?vue&type=script&lang=js"
export * from "./ArchiveNotification.vue?vue&type=script&lang=js"
import style0 from "./ArchiveNotification.vue?vue&type=style&index=0&id=f93612ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93612ce",
  null
  
)

export default component.exports